import { useEffect } from 'react';

export default function AppHome() {
  useEffect(() => {
    // Beta mode - redirect directly to game
    window.location.href = 'https://play.counterscripthq.com/data-hub';
  }, []);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <p className="text-white text-xl">Redirecting to game...</p>
    </div>
  );
}
